<app-page-unavailable *ngIf="lockScreen || lockScreenWithoutDevice"
                      [lockScreenWithoutDevice]="lockScreenWithoutDevice" xmlns="http://www.w3.org/1999/html"/>

<ng-container *ngIf="!lockScreen && !lockScreenWithoutDevice">
  <lib-poll-manager [poll]="poll"
    [incentive]="incentive"
    [isLoadingDone]="pollIsLoadingDone"
    (onFinishPoll)="onFinishPoll($event)" />

  <app-poll-alert-overlay
    *ngIf="(uiState === uiStates.ALERT_LEVEL_1 || uiState === uiStates.ALERT_LEVEL_2) && activeAlertLevel !== null"
    [level]="activeAlertLevel" />

  <app-poll-block-screen *ngIf="uiState === uiStates.BLOCKED_LEVEL_3"
    [validatingPin]="pinValidationInProgress"
    [resendLoading]="resendCodeLoading"
    [resendCooldownSeconds]="resendCooldownSeconds"
    [validationError]="pinValidationError"
    (validatePin)="onValidatePin($event)"
    (resendCode)="onResendCode()" />

  <div class="unlock-overlay"
    *ngIf="uiState === uiStates.UNLOCK_SUCCESS"
    role="status"
    aria-live="polite">
    <div class="unlock-card">
      <p class="illustration"
        aria-hidden="true">✅</p>
      <p class="title">Dispositivo desbloqueado com sucesso</p>
      <p class="description">A pesquisa sera retomada em instantes.</p>
    </div>
  </div>


  <app-footer [unit]="unit" />
</ng-container>
